(() => {
  const initializeSlider = (root) => {
    if (!root || root.dataset.sliderInitialized === 'true' || typeof window.Swiper === 'undefined') return;

    const swiperElement = root.querySelector('.article-slider__swiper');
    if (!swiperElement) return;

    const slideCount = Number(root.dataset.slideCount || 0);
    // 0, blank or invalid values fall back to the automatic defaults.
    const slidesPerView = Number(root.dataset.slidesPerView) || 4;
    const tabletSlidesPerView = Number(root.dataset.slidesPerViewTablet) || 0;
    const mobileSlidesPerView = Number(root.dataset.slidesPerViewMobile) || 1;
    const maxSlidesPerView = Math.max(slidesPerView, tabletSlidesPerView, mobileSlidesPerView);
    const previousButton = root.querySelector('.swiper-button-prev');
    const nextButton = root.querySelector('.swiper-button-next');

    new window.Swiper(swiperElement, {
      loop: slideCount > maxSlidesPerView,
      rewind: slideCount > 1 && slideCount <= maxSlidesPerView,
      slidesPerView: mobileSlidesPerView,
      spaceBetween: 10,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton,
      },
      breakpoints: {
        750: {
          slidesPerView: tabletSlidesPerView || Math.min(2, slidesPerView),
          spaceBetween: 10,
        },
        990: {
          slidesPerView: tabletSlidesPerView || Math.min(3, slidesPerView),
          spaceBetween: 10,
        },
        1200: {
          slidesPerView,
          spaceBetween: 10,
        },
      },
    });

    root.dataset.sliderInitialized = 'true';
  };

  const initializeWithin = (scope = document) => {
    if (scope.matches?.('[data-article-image-slider]')) initializeSlider(scope);
    scope.querySelectorAll?.('[data-article-image-slider]').forEach(initializeSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin());
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-article-image-slider]').forEach((slider) => {
      if (slider.swiper) slider.swiper.destroy(true, true);
      delete slider.dataset.sliderInitialized;
    });
  });
})();
